// extracted by mini-css-extract-plugin
export default {"userInput":"Demo-userInput","textInputs":"Demo-textInputs"};